import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tour-details/page.tsx");
